/** The current invitation-bound provider charges USD; locale changes display, not currency. */
export function paymentCurrency(amount: number, locale = 'en-US', compact = false): string {
  const options: Intl.NumberFormatOptions = {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: compact && Number.isInteger(amount) ? 0 : 2,
    maximumFractionDigits: 2,
  };
  try {
    return new Intl.NumberFormat(locale, options).format(amount);
  } catch {
    return new Intl.NumberFormat('en-US', options).format(amount);
  }
}
